export default __webpack_public_path__ + "static/media/france-paris-eiffel-tower.cc3e8b31.jpg";